import { render, staticRenderFns } from "./MonetaryCompensationMethods.vue?vue&type=template&id=6ab38687"
import script from "./MonetaryCompensationMethods.vue?vue&type=script&lang=js"
export * from "./MonetaryCompensationMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports